import type { PropDefaults, PropElement, PropTypes } from "@platform/react-storybook/Component";

import type { UuidText } from "@front/components/Element/Text/types";

import Namespace from "./_index.scss";

export const { NAME_ASSESSMENT, TYPE_ASSESSMENT } = Namespace;

export const RATING_ASSESSMENT = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
} as const;

export type RatingAssessment = typeof RATING_ASSESSMENT[keyof typeof RATING_ASSESSMENT];

export type CommentAssessment = {
    id: string;
    featuredMessage: UuidText;
    comment: UuidText;
    userComment: UuidText;
    userInformation: string;
    rating: RatingAssessment;
};

export type PropAssessment = PropElement & {
    /** App comment */
    comment: UuidText;
    /** Valuation value between1 and 5 */
    rating: RatingAssessment;
    /** Number of people who voted  */
    reviews: number;
    /** User Comments List */
    comments: CommentAssessment[];
};

export const DEF_ASSESSMENT: PropDefaults<PropAssessment> = {};

export type PropTypesAssessment = PropTypes<PropAssessment, typeof DEF_ASSESSMENT>;
